/**
 * Feature flags controlled by REACT_APP_ENV.
 * Set REACT_APP_ENV=DEV in .env.local to enable dev-only features.
 */

const isDev = process.env.REACT_APP_ENV === "DEV";

export const FeatureFlags = {
  /** Primary/secondary dimension grouping with ratio metric and overall rows */
  dimensionGroups: isDev,
  /** Explorer query links from team report sections and player pages */
  teamReportExplorerLinks: isDev,
  /**
   * Explicit provider choice in the query builder (element 0 `source`) and the
   * `Source` dimension / filter. The product never offers a provider choice
   * (CTG migration DESIGN §11 q3): sources resolve by season.
   */
  sourcePicker: isDev,
  /**
   * Provider labels: a query's resolved sources, the detail charts'
   * `resolution`, a team report's `source` (and the `?source=` comparison
   * reports), a roll-up scope's `context.source`. Dev comparison aid only.
   */
  sourceLabel: isDev,
} as const;
